export default __webpack_public_path__ + "assets/desktop.d05a65ec.webp";